(function () {
  'use strict';
  function positiveInteger(value, label) {
    if (!/^[1-9]\d*$/.test(String(value)) || !Number.isSafeInteger(Number(value))) {
      throw new Error(label + ' must be a positive whole-number quantity.');
    }
    return Number(value);
  }
  function buildKit(input) {
    var items = [], seen = new Set(), total = 0, count = 0;
    function add(variant, quantity) {
      var id = positiveInteger(variant.id, 'Variant ID');
      var qty = positiveInteger(quantity, 'Item quantity');
      if (!variant.available) throw new Error('A selected item is not available.');
      if (!Number.isSafeInteger(variant.price) || variant.price < 0) throw new Error('Invalid item price.');
      if (seen.has(id)) throw new Error('Duplicate variant in kit.');
      seen.add(id);
      total += variant.price * qty;
      if (!Number.isSafeInteger(total)) throw new Error('Kit total is too large.');
      items.push({ id: id, quantity: qty });
    }
    add(input.radio, input.quantity);
    (input.accessories || []).forEach(function (accessory) {
      if (!accessory.selected) return;
      add(accessory, accessory.quantity);
      count += 1;
    });
    return { items: items, totalCents: total, accessoryCount: count };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { buildKit: buildKit };
  if (typeof document === 'undefined') return;

  function init(moduleEl) {
    if (moduleEl.dataset.kitReady) return;
    var root = moduleEl.closest('[data-dk-pdp]');
    var dataEl = moduleEl.querySelector('[data-kit-data]');
    if (!root || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
    moduleEl.dataset.kitReady = 'true';
    var button = moduleEl.querySelector('[data-kit-add]');
    var error = moduleEl.querySelector('[data-kit-error]');
    var totalEl = moduleEl.querySelector('[data-kit-total]');
    var selectionEl = moduleEl.querySelector('[data-kit-radio-selection]');
    var message = moduleEl.querySelector('[data-kit-status]');
    var cartLink = moduleEl.querySelector('[data-kit-cart-link]');
    var busy = false, scheduled = false;
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: moduleEl.dataset.currency
    });
    function snapshot() {
      var idEl = root.querySelector('[data-dk-pdp-variant-id]');
      var qtyEl = root.querySelector('[data-dk-qty-input]');
      var ordinaryAdd = root.querySelector('[data-dk-pdp-add]');
      var variant = data.variants.find(function (v) { return String(v.id) === (idEl && idEl.value); });
      if (!variant || (ordinaryAdd && ordinaryAdd.disabled)) throw new Error('Choose an available radio option.');
      var accessories = Array.from(moduleEl.querySelectorAll('[data-kit-accessory]')).map(function (row) {
        var choice = data.accessories.find(function (v) { return String(v.id) === row.dataset.kitAccessory; });
        return Object.assign({}, choice, {
          selected: row.querySelector('[data-kit-checkbox]').checked,
          quantity: row.querySelector('[data-kit-qty]').value
        });
      });
      return { radio: variant, quantity: qtyEl ? qtyEl.value : '1', accessories: accessories };
    }
    function setError(text) {
      error.textContent = text || '';
      error.hidden = !text;
    }
    function update() {
      scheduled = false;
      try {
        var current = snapshot();
        var kit = buildKit(current);
        var title = data.title;
        if (current.radio.title && current.radio.title !== 'Default Title') title += ' — ' + current.radio.title;
        selectionEl.textContent = current.quantity + ' × ' + title;
        totalEl.textContent = formatter.format(kit.totalCents / 100);
        button.disabled = busy || kit.accessoryCount < 1;
        button.setAttribute('aria-disabled', String(button.disabled));
      } catch (e) {
        totalEl.textContent = '—';
        selectionEl.textContent = 'Choose an available radio option and whole-number quantities.';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
      moduleEl.querySelectorAll('[data-kit-accessory]').forEach(function (row) {
        row.querySelector('[data-kit-qty]').disabled = !row.querySelector('[data-kit-checkbox]').checked || busy;
      });
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      // Read after the existing PDP option/quantity handlers have updated their values.
      setTimeout(update, 0);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-dk-opt-value], [data-dk-qty-inc], [data-dk-qty-dec]')) schedule();
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-dk-qty-input], [data-kit-qty]')) { setError(''); schedule(); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-dk-qty-input], [data-kit-qty], [data-kit-checkbox], [data-dk-pdp-variant-id]')) {
        setError(''); message.textContent = ''; schedule();
      }
    });
    document.addEventListener('dk:pdp:variant', function () { if (moduleEl.isConnected) schedule(); });
    var hidden = root.querySelector('[data-dk-pdp-variant-id]');
    var add = root.querySelector('[data-dk-pdp-add]');
    if (hidden) new MutationObserver(schedule).observe(hidden, { attributes: true, attributeFilter: ['value'] });
    if (add) new MutationObserver(schedule).observe(add, { attributes: true, attributeFilter: ['disabled'] });

    button.addEventListener('click', async function () {
      if (busy) return;
      setError(''); message.textContent = ''; cartLink.hidden = true;
      var kit;
      try {
        kit = buildKit(snapshot());
        if (kit.accessoryCount < 1) throw new Error('Select at least one accessory for your kit.');
      } catch (e) { setError(e.message); update(); return; }
      busy = true; button.textContent = 'Adding kit…'; update();
      moduleEl.setAttribute('aria-busy', 'true');
      try {
        var response = await fetch(moduleEl.dataset.cartAdd || '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: kit.items })
        });
        if (!response.ok) {
          var failure = await response.json().catch(function () { return {}; });
          throw new Error(failure.description || failure.message || 'Could not add this kit. Review availability and try again.');
        }
        message.textContent = 'Kit added to cart.';
        cartLink.hidden = false;
        // A drawer refresh failure must not suggest that the successful cart addition failed.
        try {
          if (window.DK && window.DK.cart && window.DK.cart.refresh) await window.DK.cart.refresh();
          if (window.DK && window.DK.openCart) window.DK.openCart();
        } catch (_) { message.textContent = 'Kit added. Open your cart to review it.'; }
      } catch (e) {
        setError(e instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : e.message);
      } finally {
        busy = false; button.textContent = 'Add kit to cart';
        moduleEl.setAttribute('aria-busy', 'false'); update();
      }
    });
    update();
  }
  function initAll() { document.querySelectorAll('[data-dateck-kit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
